import React from 'react';

const OutputCard = ({ label, value, colour, simple, feedback }) => {
  const bgColor = {
    blue: 'bg-blue-100 dark:bg-blue-900/20', teal: 'bg-teal-100 dark:bg-teal-900/20', green: 'bg-green-100 dark:bg-green-900/20', cyan: 'bg-cyan-100 dark:bg-cyan-900/20',
    purple: 'bg-purple-100 dark:bg-purple-900/20', indigo: 'bg-indigo-100 dark:bg-indigo-900/20', pink: 'bg-pink-100 dark:bg-pink-900/20'
  }[colour];
  const borderColor = {
    blue: 'border-blue-300 dark:border-blue-900', teal: 'border-teal-300 dark:border-teal-900', green: 'border-green-300 dark:border-green-900', cyan: 'border-cyan-300 dark:border-cyan-900',
    purple: 'border-purple-300 dark:border-purple-900', indigo: 'border-indigo-300 dark:border-indigo-900', pink: 'border-pink-300 dark:border-pink-900'
  }[colour];
  const textColor = {
    blue: 'text-blue-800 dark:text-blue-400', teal: 'text-teal-800 dark:text-teal-400', green: 'text-green-800 dark:text-green-400', cyan: 'text-cyan-800 dark:text-cyan-400',
    purple: 'text-purple-800 dark:text-purple-400', indigo: 'text-indigo-800 dark:text-indigo-400', pink: 'text-pink-800 dark:text-pink-400'
  }[colour];
  const labelColour = {
    blue: 'text-blue-600 dark:text-blue-300', teal: 'text-teal-600 dark:text-teal-300', green: 'text-green-600 dark:text-green-300', cyan: 'text-cyan-600 dark:text-cyan-300',
    purple: 'text-purple-600 dark:text-purple-300', indigo: 'text-indigo-600 dark:text-indigo-300', pink: 'text-pink-600 dark:text-pink-300'
  }[colour];
  
  return (
    <div className={`${bgColor} rounded-xl p-4 md:p-5 shadow-md border ${borderColor} transition-transform transform hover:scale-105 duration-200`}>
      <h3 className={`text-sm md:text-base ${labelColour} font-semibold mb-2 text-center`}>{label}</h3>
      <p className={`text-xl md:text-2xl font-bold ${textColor} text-center`}>{value}</p>
      {feedback && feedback !== '-' && (
        <div className="text-center mt-2 text-sm font-semibold text-gray-500 dark:text-gray-400">
          ({feedback})
        </div>
      )}
    </div>
  );
};

export default OutputCard;